
import { defineComponent } from 'vue'
import {HomeTemplate} from '@/components/templates'

export default defineComponent({
  components: { HomeTemplate }
})
